<footer
  class="bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 p-2 text-center text-sm shadow-inner mt-auto">
  <div
    class="container mx-auto flex flex-col md:flex-row justify-center items-center space-y-2 md:space-y-0 md:space-x-4">
    <span data-cy="page-layout-span-copyright">&copy; 2025 OrganizeMED by Pranava Inc. All rights reserved.</span>
    <span class="text-xs" data-cy="page-layout-span-buildInfo">{{ build }}</span>
  </div>
</footer>